import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { settings } from "../../Services/apiSetting";
import SeoHelmet from "./seoHelmet";

export default function StaticSeoManager() {
  const location = useLocation();

  const [seoList, setSeoList] = useState({});
  const [seo, setSeo] = useState(null);

  const isDynamicProductPage = location.pathname.startsWith("/product/");

  useEffect(() => {
    if (isDynamicProductPage) {
      setSeo(null);
      return;
    }

    fetch(settings.staticSEOJsonUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load SEO JSON: ${res.status}`);
        }

        return res.json();
      })
      .then((data) => {
        setSeoList(data);
      })
      .catch((error) => {
        console.error("Failed to load SEO JSON:", error);
        setSeoList({});
      });
  }, [isDynamicProductPage]);

  useEffect(() => {
    if (isDynamicProductPage) {
      setSeo(null);
      return;
    }

    const path = location.pathname.replace(/\/+$/, "") || "/";

    setSeo(seoList[path] || null);
  }, [location.pathname, seoList, isDynamicProductPage]);

  return <SeoHelmet seo={seo} />;
}
